import { combineReducers } from 'redux';
import managerUsersReducers from './features/settings/reducers/managerUsersReducers';
import businessReducers from './features/settings/reducers/businessReducers';
import shopsReducers from './reducers/shopsReducers';
import credentialsReducers from './features/credentials/reducer';
import operationsReducers from './features/operations/reducer';
import userReducers from './reducers/userReducers';
import { dashboardReducer } from './features/dashboard/reducer';
import { reportsReducer } from './features/reports/reducer';
import filtersReducers from './reducers/filtersReducers';
import { chargebacksReducer } from './features/chargebacks/reducer';
import { clearingsReducer } from './features/clearings/reducer';
import { taxesReducer } from './features/taxes/reducer';

const allReducers = combineReducers({
  business: businessReducers,
  managerUsers: managerUsersReducers,
  shops: shopsReducers,
  credentials: credentialsReducers,
  user: userReducers,
  operations: operationsReducers,
  dashboard: dashboardReducer,
  filters: filtersReducers,
  chargebacks: chargebacksReducer,
  reports: reportsReducer,
  clearings: clearingsReducer,
  taxes: taxesReducer
});

export type RootState = ReturnType<typeof allReducers>;

export default allReducers;
